// extracted by mini-css-extract-plugin
module.exports = {"stepper__wrapper":"q_4","stepper__view":"q_5","stepper__buttons":"q_6","stepper__button":"q_7","stepper__button__active":"q_8"};